import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import WebsiteLayoutWS from '../WebsiteLayoutWS';
import Hero from '../components/Hero';
import Advantages from '../components/Advantages';
import Solutions from '../components/Solutions';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';
import FeatureElement from '../components/FeatureElement';

const HomeWs = ({ businessData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <WebsiteLayoutWS>
      <Helmet>
        <title>CHEK UP - {t('workshopManagement')}</title>
        <meta
          name="description"
          content={t('metaDescription')}
        />
      </Helmet>
      <Hero />

      <Advantages title={t('heroTitle')} />

      <FeatureElement
        orientation="lr"
        title={t('feature1Title')}
        description={t('feature1Description')}
        image="/assets/chekup/Home1.png"
        linkLabel={t('feature1Link')}
        linkUrl="/outils/planification"
        listItems={[
          {
            title: t('feature1Item1Title'),
            description: t('feature1Item1Desc'),
          },
          {
            title: t('feature1Item2Title'),
            description: t('feature1Item2Desc'),
          },
          {
            title: t('feature1Item3Title'),
            description: t('feature1Item3Desc'),
          },
        ]}
      />

      <FeatureElement
        orientation="rl"
        title={t('feature2Title')}
        description={t('feature2Description')}
        image="/assets/chekup/Home2.png"
        linkLabel={t('feature2Link')}
        linkUrl="/outils/inventaire"
        listItems={[
          {
            title: t('feature2Item1Title'),
            description: t('feature2Item1Desc'),
          },
          {
            title: t('feature2Item2Title'),
            description: t('feature2Item2Desc'),
          },
          {
            title: t('feature2Item3Title'),
            description: t('feature2Item3Desc'),
          },
        ]}
      />

      <FeatureElement
        orientation="lr"
        title={t('feature3Title')}
        description={t('feature3Description')}
        image="/assets/chekup/Home3.png"
        linkLabel={t('feature3Link')}
        linkUrl="/fonctionnalites/communication"
        listItems={[
          {
            title: t('feature3Item1Title'),
            description: t('feature3Item1Desc'),
          },
          {
            title: t('feature3Item2Title'),
            description: t('feature3Item2Desc'),
          },
          {
            title: t('feature3Item3Title'),
            description: t('feature3Item3Desc'),
          },
        ]}
      />

      <Solutions title={t('solutionsTitle')} />

      <Testimonials title={t('testimonialsTitle')} />

      <CallToAction
        title={t('ctaTitle')}
        description={t('ctaDescription')}
        primaryButtonText={t('ctaPrimaryButton')}
        primaryButtonLink="/onboard"
        secondaryButtonText={t('ctaSecondaryButton')}
        secondaryButtonLink="/demo"
      />
    </WebsiteLayoutWS>
  );
};

export default HomeWs;
